// extracted by mini-css-extract-plugin
export default {"root":"distribute-sides_root__M5km3","column":"distribute-sides_column__1yeN3"};